import { jsx as _jsx } from "react/jsx-runtime";
import { Trustpilot0Stars } from '../assets/0star';
import { Trustpilot1Stars } from '../assets/1star';
import { Trustpilot1NHalfStars } from '../assets/1.5star';
import { Trustpilot2Stars } from '../assets/2star';
import { Trustpilot2NHalfStars } from '../assets/2.5star';
import { Trustpilot3NHalfStars } from '../assets/3.5star';
import { Trustpilot3Stars } from '../assets/3star';
import { Trustpilot4Stars } from '../assets/4star';
import { Trustpilot4NHalfStars } from '../assets/4.5star';
import { Trustpilot5Stars } from '../assets/5star';
export var trustpilotRatingImage = {
    0: _jsx(Trustpilot0Stars, {}),
    1: _jsx(Trustpilot1Stars, {}),
    1.5: _jsx(Trustpilot1NHalfStars, {}),
    2: _jsx(Trustpilot2Stars, {}),
    2.5: _jsx(Trustpilot2NHalfStars, {}),
    3: _jsx(Trustpilot3Stars, {}),
    3.5: _jsx(Trustpilot3NHalfStars, {}),
    4: _jsx(Trustpilot4Stars, {}),
    4.5: _jsx(Trustpilot4NHalfStars, {}),
    5: _jsx(Trustpilot5Stars, {}),
};
